import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
  ROUTE_PATH
} from "../../../app/constants";
import { Header, Paragraph, Button, ErrorMark } from "../../../components/RegularComponents";
import CheckboxForm from "../../../components/CheckBoxForm";
import TopNavigationBar from "../../TopNavigationBar";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { ERROR_STRING } from "../../../app/errors";
import { fullName } from "../../../app/utils";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";

const MORTGAGE_APPLICATION_PROPERTY = "principalBrokerDutiesConfirmation";

export const ComplianceOfficerDutiesConfirmation = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();
  const { application } = usePathApplication();

  const [confirmCheck1, setConfirmCheck1] = useState(false);
  const [confirmCheck2, setConfirmCheck2] = useState(false);

  const [showValidationError, setShowValidationError] = useState(false);

  const { agencyApplication } = useSelector(agencyApplicationSelector) || {};
  let mainAgentPersonData = agencyApplication.businessLicenceData?.personData;

  const handleNext = () => {
    if (!confirmCheck1 || !confirmCheck2) {
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);

    // Set MORTGAGE PROP value
    dispatch(
      setMortgageProperty({
        key: "principalBrokerDutiesConfirmation",
        value: true
      })
    );

    // On to the next item
    dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_APPLICATION_REVIEW}`));

    // compliance officers under Mortage lender do not have a separate licence number
    // dispatch(
    //   push(
    //     `/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONFIRM_CURRENT_NS_LICENCE_NUMBER}`
    //   )
    // );
  };

  const handleModalClose = () => {
    // Set MORTGAGE PROP value
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: confirmCheck1 && confirmCheck2
      })
    );

    onEditSave();
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar
              {...props}
              applicationType={APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE}
              applicationMode={APPLICATION_MODE_NEW}
            />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "20px" }}
                  id="broker-confirmation-header"
                  header="Confirmation"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-1"
              checked={confirmCheck1}
              value={confirmCheck1}
              labelStyle={{ fontWeight: "normal !important" }}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck1(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                `I, ${fullName(
                  mainAgentPersonData
                )}, confirm that I am engaged with the activities with the mortgage lender to the extent I am capable of carrying out my duties and responsibilites as Compliance Officer under the Mortgage Regulation Act and its regulations.`
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox-2"
              checked={confirmCheck2}
              value={confirmCheck2}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck2(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[
                `I, ${fullName(
                  mainAgentPersonData
                )}, confirm that I have read and understand the Mortgage Regulation Act and its regulations and l agree to carry out my duties and responsibilities under the Act and its regulations.`
              ]}
            />
          </div>
        </div>

        <div className="row topMarginNormal">
          <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleNext : handleModalClose}
            />
            {showValidationError && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
